import { render } from "./SFormElement.vue?vue&type=template&id=13fb39a2"
import script from "./SFormElement.vue?vue&type=script&lang=js"
export * from "./SFormElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__